// extracted by mini-css-extract-plugin
module.exports = {"buttons":"FormItemControls-module__buttons___LxsAv","buttonFirst":"FormItemControls-module__buttonFirst___e3BrG"};